import type { BreederListPageFormValues } from '@presentation/pages';

export const PAGINATED_SIZE = 24;

export const FORM_INITIAL_VALUES: BreederListPageFormValues = {
  breedNames: [],
  hasLitters: undefined,
  levels: [],
  pedigree: [],
  // sortBy: BreederListSortType.CONNECTION_DESC,
  spokenLanguages: undefined,
  countries: undefined,
  regions: undefined,
};
